import { render, staticRenderFns } from "./FoodServiceBrands.vue?vue&type=template&id=213a1f2a&scoped=true"
import script from "./FoodServiceBrands.vue?vue&type=script&lang=js"
export * from "./FoodServiceBrands.vue?vue&type=script&lang=js"
import style0 from "./FoodServiceBrands.vue?vue&type=style&index=0&id=213a1f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a1f2a",
  null
  
)

export default component.exports